const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-maps",
    meta: {},
    name: "m-maps",
    component: () => import("@/modules/mmaps/RootView")
});

export default Routes;